const style = {
  main: {
    sx: {
      alignItems: 'center',
      display: 'flex',
      p: 2,
    },
  },
} as const;

export default style;
